import Spinner from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import { useRef, useState } from "react";
import { endpoints } from "../../../hooks/endpoints";
import { convertText, getToken } from "../../../hooks/utils";

const CheckCode = () => {
  const [couponInfo, setCouponInfo] = useState(null);
  const [isCouponLoading, setIsCouponLoading] = useState(false);
  const coupon = useRef();

  const handleCheckCoupon = (e) => {
    e.preventDefault();
    setIsCouponLoading(true);
    fetch(
      endpoints.checkCoupon +
        `?coupon=${
          (coupon.current as any).value
        }&timestamp=${new Date().getTime()}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
        method: "GET",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setCouponInfo(data);
        setIsCouponLoading(false);
        console.log(data);
      })
      .catch((err) => {
        console.log(err);
        setIsCouponLoading(false);
      });
  };

  return (
    <div className="p-3 rounded-lg border shadow-sm bg-white">
      <h4 className="m-2 mb-3 p-2 w-fit border-b-2 border-primary font-bold">
        الكشف عن كود
      </h4>

      <div className="mb-3">
        <input
          ref={coupon}
          type="text"
          id="exampleFormControlInput1"
          placeholder="أكتب الكود هنا..."
          className="border border-gray-300 rounded-md p-2 w-full focus:outline-none focus:ring-2 focus:ring-primary"
        />
      </div>

      <Button className="rounded-lg px-4 py-2" onClick={handleCheckCoupon}>
        {isCouponLoading ? <Spinner variant="button" /> : "بحث"}
      </Button>

      {couponInfo && couponInfo.found ? (
        <div
          className={`${
            couponInfo.usage.limit > couponInfo.usage.used
              ? "bg-blue-100 text-blue-800"
              : "bg-red-100 text-red-700"
          } rounded-lg my-2 p-4 w-fit`}
          role="alert"
        >
          <p>
            <span className="font-bold">الكود: </span>
            <span>{couponInfo.code}</span>
          </p>
          <p>
            <span className="font-bold">الحالة: </span>
            {couponInfo.usage.limit > couponInfo.usage.used ? (
              <span className="text-green-600 font-bold">الكود ساري</span>
            ) : (
              <span className="text-red-600 font-bold">الكود مستخدم</span>
            )}
          </p>
          {couponInfo.discount_type !== "fixed_cart" && (
            <>
              <span className="font-bold">نطاق الكود: </span>
              <ul className="space-y-1 my-2 bg-white/80 rounded-lg p-2 border border-gray-300">
                {[...couponInfo.products, ...couponInfo.categories].map(
                  (title, index) =>
                    title && (
                      <li key={index} className="w-fit">
                        • {convertText(title.split("|")[0])}
                      </li>
                    )
                )}
              </ul>
            </>
          )}

          {(couponInfo.teacher_from_cat || couponInfo.teacher_from_lesson) &&
            JSON.parse(localStorage.getItem("user")).user_email ===
              "mail.teacheracademy@gmail.com" && (
              <p className="flex flex-wrap">
                <span className="font-bold">المدرس: </span>{" "}
                {couponInfo.teacher_from_cat}
                {couponInfo.teacher_from_lesson}
              </p>
            )}

          {couponInfo.discount_type === "fixed_cart" && couponInfo.amount && (
            <p className="my-1">
              <span className="font-bold">رصيد الكود: </span>
              <span>{couponInfo.amount}</span>
              <span className="mx-1">جنيه</span>
            </p>
          )}

          {couponInfo.customer && (
            <p>
              قام <span className="font-bold">{couponInfo.customer}</span>{" "}
              بإستخدام هذا الكود
            </p>
          )}
        </div>
      ) : couponInfo && !couponInfo.found ? (
        <div
          className="bg-red-100 text-red-700 rounded-lg my-2 p-4 w-fit"
          role="alert"
        >
          الكود غير صحيح
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default CheckCode;
